import { render, staticRenderFns } from "./mxy.vue?vue&type=template&id=bf1ed0a2&"
import script from "./mxy.vue?vue&type=script&lang=js&"
export * from "./mxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports